<ng-template #addGiftModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title" >New Free Gift Settings</h4>
		<button type="button" mat-icon-button aria-label="Close" (click)="modal.dismiss('Cross click')">
			<mat-icon>close</mat-icon>
		</button>
	</div>
	<div class="modal-body text-dark">
		<div class="row">
			<div class="card">
				<div class="card-body text-center">
					<div class="row">
						<div class="col-sm-6">
							<mat-form-field appearance="outline">
								<mat-label>Name</mat-label>
								<input matInput type="text" [formControl]="giftname" />
							</mat-form-field>
						</div>
						<div class="col-sm-6">
							<mat-form-field appearance="outline">
								<mat-label>Description</mat-label>
								<input matInput type="text" [formControl]="giftdesc" />
							</mat-form-field>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-6">
						<mat-form-field appearance="outline">
										<mat-label>Date Range</mat-label>
										<mat-date-range-input [rangePicker]="picker">
											<input matStartDate [formControl]="giftstart" placeholder="Start date">
											<input matEndDate [formControl]="giftend" placeholder="End date">
										</mat-date-range-input>
										<mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
										<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
										<mat-date-range-picker #picker></mat-date-range-picker>
									</mat-form-field>
						</div>
						<div class="col-sm-6">
							<mat-form-field appearance="outline">
								<mat-label>Spending Threshold</mat-label>
								<input matInput type="text" [formControl]="giftthresh" />
							</mat-form-field>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-6">
						<mat-form-field appearance="outline">
										<mat-label>Brand</mat-label>
										<mat-select type="text" [formControl]="giftman" >
										<mat-option value="0"> --- Any ---</mat-option>
										<mat-option *ngFor="let m of manufacturers;" [value]="m.manufacturer_id">{{m.name}}</mat-option>
										</mat-select>
									</mat-form-field>
						</div>
						<div class="col-sm-6">
							<mat-form-field appearance="outline">
										<mat-label>Location</mat-label>
										<mat-select [formControl]="giftloc" multiple #branchFilter appSelectAll>
										<mat-option value="95"> Web Sales </mat-option>
										<mat-option *ngFor="let m of locations;" [value]="m.loccode">{{m.locationname}}</mat-option>
										</mat-select>
									</mat-form-field>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<button mat-stroked-button color="primary" (click)="addGift();">
			<mat-icon>add</mat-icon>
			Add Free-Gift
		</button>
	</div>
</ng-template>
<ng-container *ngIf="editinggift.name">
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title" >Edit Free Gift Settings</h4>
		<button type="button" mat-icon-button aria-label="Close" (click)="modal.dismiss('Cross click')">
			<mat-icon>close</mat-icon>
		</button>
	</div>
	<div class="modal-body text-dark">
		<div class="row">
			<div class="card">
				<div class="card-body text-center">
					<div class="row">
						<div class="col-sm-6">
							<mat-form-field appearance="outline">
								<mat-label>Name</mat-label>
								<input matInput type="text" [formControl]="egiftname" />
							</mat-form-field>
						</div>
						<div class="col-sm-6">
							<mat-form-field appearance="outline">
								<mat-label>Description</mat-label>
								<input matInput type="text" [formControl]="egiftdesc" />
							</mat-form-field>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-6">
						<mat-form-field appearance="outline">
										<mat-label>Date Range</mat-label>
										<mat-date-range-input [rangePicker]="picker">
											<input matStartDate [formControl]="egiftstart" placeholder="Start date">
											<input matEndDate [formControl]="egiftend" placeholder="End date">
										</mat-date-range-input>
										<mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
										<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
										<mat-date-range-picker #picker></mat-date-range-picker>
									</mat-form-field>
						</div>
						<div class="col-sm-6">
							<mat-form-field appearance="outline">
								<mat-label>Spending Threshold</mat-label>
								<input matInput type="text" [formControl]="egiftthresh" />
							</mat-form-field>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-6">
						<mat-form-field appearance="outline">
										<mat-label>Brand</mat-label>
										<mat-select type="text" [formControl]="egiftman" >
										<mat-option value="0"> --- Any ---</mat-option>
										<mat-option *ngFor="let m of manufacturers;" [value]="m.manufacturer_id">{{m.name}}</mat-option>
										</mat-select>
									</mat-form-field>
						</div>
						<div class="col-sm-6">
							<mat-form-field appearance="outline">
										<mat-label>Location</mat-label>
										<mat-select [formControl]="egiftloc" multiple appSelectAll>
										<mat-option value="95"> Web Sales </mat-option>
										<mat-option *ngFor="let m of locations;" [value]="m.loccode">{{m.locationname}}</mat-option>
										</mat-select>
									</mat-form-field>
						</div>
					</div>
					<div class="row">
					<h4> Giftable Items </h4>
					</div>
					<div class="row mb-2">
						<table class="table table-striped table-hover table-bordered">
											<thead class="thead-dark">
												<tr>
													<th scope="col">Item Number</th>
													<th scope="col">Description</th>
													<th></th>
												</tr>
											</thead>
											<tbody>
												<ng-container *ngFor="let i of editinggift.items">
												<tr>
													<td>{{ i.stockid}}</td>
													<td>{{ i.description}}</td>
													<td><button mat-icon-button (click)="deleteitem(i)" title="Delete"><mat-icon>remove</mat-icon></button></td>
												</tr>
												</ng-container>
											</tbody>
						</table>
					</div>
					<app-item-picker (saveresults)="addItems($event);"></app-item-picker>

				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<button mat-stroked-button color="primary" (click)="updateGift();">
			<mat-icon>add</mat-icon>
			Save Free-Gift
		</button>
	</div>
</ng-container>
<div class="card m-0">
<div class="card-body">
<div class="row mb-2">
				<div class="col-2">
				<button mat-stroked-button color="primary" (click)="addFreeGift()"> New Free Gift </button>
				</div>
</div>
<div class="row mb-2">
<table class="table table-striped table-hover table-bordered">
											<thead class="thead-dark">
												<tr>
													<th scope="col"></th>
													<th scope="col">Name</th>
													<th scope="col">Description</th>
													<th scope="col">Start Date</th>
													<th scope="col">End Date</th>
													<th scope="col">Spending Threshold</th>
													<th></th>
												</tr>
											</thead>
											<tbody>
												<ng-container *ngFor="let s of freegifts">
												<tr>
												    <td class="text-center">
														
													</td>
													<td>{{ s.name}}</td>
													<td>{{ s.description}}</td>
													<td>{{ s.startdate | date: 'MM/dd/YYYY' }}</td>
													<td>{{ s.enddate | date: 'MM/dd/YYYY' }}</td>
													<td>{{ s.threshold | currency}}</td>
													<td><button mat-icon-button (click)="editGift(s)" title="Edit"><mat-icon>edit</mat-icon></button>
													<button mat-icon-button (click)="deleteGift(s.id)" title="Delete"><mat-icon>remove</mat-icon></button></td>
												</tr>
												</ng-container>
											</tbody>
										</table>
										</div>
	</div>
</div>